export const DEMO_TICK_INTERVAL_MS = 12_000;
/** Interval for the banker-facing live play feed (non-lister sessions). */
export const DEMO_PLAY_FEED_INTERVAL_MS = 4_000;
/** Max plays the live feed creates per non-lister session. */
export const DEMO_PLAY_FEED_MAX = 5;
export const DEMO_TICKS_STORAGE_KEY = 'bolita_demo_ticks_enabled';

export function readDemoTicksEnabled(): boolean {
  if (typeof window === 'undefined') return true;
  const stored = window.localStorage.getItem(DEMO_TICKS_STORAGE_KEY);
  if (stored === null) return true;
  return stored === 'true';
}

export function writeDemoTicksEnabled(enabled: boolean) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(DEMO_TICKS_STORAGE_KEY, enabled ? 'true' : 'false');
}
